import React, { useState } from 'react';

import './Review.css';

import { create, get } from '../redux/reducers'

import Review from '../compObjects/Review';
import { useDispatch } from 'react-redux'

import { formatDate } from '../util/util';


function ReviewNew(props) {

    const dispatch=useDispatch()

    
    const [objectInputState, setObjectInputState] = useState({
        "review": "review à écrire",
        "score": 12,
        "date": formatDate(Date.now()),
        "profile": props.profile,
        "movie": 1,
        "seenWithProfiles": [],
        "seenWithOutsiders": []
    }
    )

    const [editState, setEditState] = useState('EDIT')
    const [updateConclusionState, setUpdateConclusionState] = useState('NONE') //UPDATEPENDING, UPDATEFAILURE, UPDATEFULFILLED ; 

    const startSave = () => {
        dispatch(create("/api/reviews/", objectInputState,(result) => {
            dispatch(get(props.reviewsObjectId)) //if i don't do that, my father won't display the new element. And my father is not using just /api/reviews/ but /api/reviews/blablablalba
            props.setCreateState("NOCREATE")}))
        props.setCreateState("CREATEPENDING")
    }



    return ( 
        <Review
            type={props.type}

            objectInputState={objectInputState}
            setObjectInputState={setObjectInputState}

            editState={editState}
            setEditState={setEditState}
            updateConclusionState={updateConclusionState}
            setUpdateConclusionState={setUpdateConclusionState}

            startSave={startSave}

        />

    );
}

export default ReviewNew;